<div class="content-block">
  <article class="article " style="margin-top:1rem">
    
    <div class="title-container">
      <button class="btn btn-back" (click)="back()"><i class="fas fa-caret-left"></i> Back</button>
      <div style="flex: 10;">
        <h2>Import Inspections</h2>
      </div>
      </div>
      
      <div style="width: 100%;margin-left: 0rem;margin-top: 1rem;display: flex;flex-direction: row;align-items: center;justify-content: space-around;">
      
      
        <div class="form-group" >
          <label>Company *</label>
          <app-company-picker [triggerRefetch]="refetchCompanies"  [accountId]="companyyId" [disable]="disableCompany"
            [_placeholder]="'Please Select'" (onCompanySet)="onCompanyChange($event)"></app-company-picker>
      
        </div>
        <div class="form-group" >
          <label>Engineer *</label>
          <app-technician-picker [technicianId]="technicianId"  [_placeholder]="'Please Select'"
            (onTechnicianSet)="onTechnicianChange($event)"></app-technician-picker>
      
        </div>
      </div>
      
      <a href="/assets/files/InspectionMaster.xlsx">Download Template</a>
    <div class="row large-margin-top">
      <input type="file" name="sig" class="btn btn-primary" style="height: 75%;width:75%;" (change)="uploadFile($event)"
        accept=".xlsx" />
    </div>
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary" (click)="upload()">Upload</button>
      </div>
    </div>
  </article>
</div>


<app-loading-icon *ngIf="loading"></app-loading-icon>